const openWindow = (url = '', newTab = true) => {
  if (typeof window === 'undefined') return

  window.open(url, newTab ? '_blank' : '_self', 'noopener,noreferrer')
}

export default openWindow
